import * as S from "./FaqPartList.style";
import { Faq } from "@/common/types/inquiry";
import { Loading } from "@/components/atoms/Loading";
import { InquiryFaqItem } from "@/components/atoms/InquiryFaqItem";

interface FaqPartListProps {
  faqs: Faq[];
  isLoading: boolean;
}

export const FaqPartList = ({ faqs, isLoading }: FaqPartListProps) => {
  if (isLoading) {
    return <Loading />;
  }

  return (
    <S.FaqPartList>
      {faqs.map((faq: Faq, idx: number) => {
        return <InquiryFaqItem faq={faq} key={idx} />;
      })}
    </S.FaqPartList>
  );
};
